import { Box, Flex, Image, Text, Button } from 'rebass';
import PropTypes from 'prop-types';
import React, { useRef, useEffect } from 'react';
import Modal from 'app/modal/v3/index';
import { IoIosArrowRoundBack } from 'react-icons/io';
import { IoVolumeMediumOutline } from 'react-icons/io5';
import { BsQrCode, BsHeartFill, BsPersonCircle } from 'react-icons/bs';
import { LuBookHeart, LuColumns2, LuPencil, LuChevronRight } from 'react-icons/lu';
import { useCurrentMember } from 'members/hooks/index';
import { toggleNewStoryVisible } from 'stories/actions';
import { useDispatch } from 'react-redux';
import store from 'store';
import examplePhoto from './assets/SimpleBook_page.png';

export function LetsBeginFooterComponent({ disabled, sx = {}, backText = 'Back', onBackDisabled, onBack, nextButtonText, onStepUp, buttonSx = {} }) {
    return <Flex
        width="100%"
        sx={{
            justifyContent: "space-between",
            alignItems: "center",
            px: "26px",
            pt: 2,
            ...sx,
        }}
    >
        {onBack && <Flex
            height={40}
            justifyContent="space-around"
            alignItems="center"
            sx={{ borderRadius: 'medium', cursor: onBackDisabled || !onBack ? 'not-allowed' : 'pointer' }}
            onClick={onBackDisabled || !onBack ? undefined : onBack}
            disabled={onBackDisabled}
        >
            <Text as={IoIosArrowRoundBack} color="mineShaft" minWidth={"24px"} fontSize={24} />
            <Text minWidth={'max-content'} color="mineShaft" fontFamily="Poppins" lineHeight={'150%'} ml={2} fontWeight={400} fontSize="15px">
                {' '}
                {backText}
            </Text>
        </Flex>}

        <Button
            height={40}
            py={1}
            px={5}
            bg={disabled ? "grey" : "brand"}
            onClick={onStepUp}
            sx={{ borderRadius: '23px', opacity: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', ...buttonSx }}
        >
            {nextButtonText}
        </Button>
    </Flex>


}

// Each bullet's icon sits in its own tinted rounded square, per the FTUE design.
const BULLETS = [
    {
        Icon: LuBookHeart,
        bg: '#FEF3C7',
        color: '#D97706',
        text: 'A book is made up of many stories',
    },
    {
        Icon: LuColumns2,
        bg: '#DBEAFE',
        color: '#0EA5E9',
        text: 'A single story can be as simple as a photo with a caption or it could have much more content',
    },
    {
        Icon: LuPencil,
        bg: '#FCE7F3',
        color: '#EC4899',
        text: 'You can easily start a story, then edit or add to it later',
    },
];

const LetsBegin = ({ setShowFTUE }) => {
    const modalRef = useRef(null);
    const dispatch = useDispatch();

    const { 'first-name': firstName } = useCurrentMember();

    const onSubmit = () => {
        setShowFTUE(false)
        store.set('ftui_watched', true)

        dispatch(toggleNewStoryVisible());
    }
    useEffect(() => {
        if (modalRef.current)
            modalRef.current.scrollTo(0, 0);

    }, []);

    const renderStep = () => {
        return (
            <Flex m="auto" mt={[2, "50px"]} flexDirection="column" justifyContent="center" alignItems="center" maxWidth={500}
                ref={modalRef}
                overflow="auto" px={2} mb={7}>
                <Text fontFamily="Bitter" textAlign="left" fontWeight="normal" alignSelf="flex-start"
                    width="100%"
                    px="26px"
                    sx={{
                        color: '#000',
                        fontFamily: 'Bitter',
                        fontSize: '30px',
                        fontWeight: '500',
                        lineHeight: '130%',
                    }}
                >
                    Welcome {firstName},<br />
                    let’s get started!
                </Text>

                <Flex
                    flexDirection="column"
                    width="100%"
                    alignSelf="flex-start"
                    px="26px"
                    mt="24px"
                    sx={{ gap: '18px' }}
                >
                    {BULLETS.map(({ Icon, bg, color, text }) => (
                        <Flex key={text} alignItems="flex-start" sx={{ gap: '14px' }}>
                            <Flex
                                flexShrink={0}
                                justifyContent="center"
                                alignItems="center"
                                width="32px"
                                height="32px"
                                bg={bg}
                                sx={{ borderRadius: '8px' }}
                            >
                                <Text as={Icon} color={color} fontSize="18px" />
                            </Flex>
                            <Text fontFamily="Poppins" fontSize="16px" fontWeight={400} lineHeight="150%" color="#0E0E0E">
                                {text}
                            </Text>
                        </Flex>
                    ))}
                </Flex>

                <LetsBeginFooterComponent
                    sx={{ justifyContent: 'center', mt: '30px', mb: '24px' }}
                    onStepUp={onSubmit}
                    nextButtonText={
                        <Flex alignItems="center" sx={{ gap: '4px' }}>
                            Start a new story
                            <Text as={LuChevronRight} fontSize="18px" />
                        </Flex>
                    }
                />

                <Box width="100%" px="26px">
                    <Image src={examplePhoto} width="100%" sx={{ display: 'block' }} />
                </Box>
            </Flex>
        );
    }

    return (
        <Modal
            maxWidth={620}
            shadeProps={{ pt: [0, 4] }}
            closeOnOutsideClick={false}
            isScrollActive={false}
            aboveTooltip
        >
            {renderStep()}
        </Modal>
    );
};

LetsBegin.propTypes = {
    setShowFTUE: PropTypes.func.isRequired,
};

export default LetsBegin;
